const YoutubeVideoComponentSourceCode = (props: { embedId: string; title: string }) => {
    // if (typeof window === 'undefined') { //nov 2023: we now render markdown to html on server.
    //   return <></>;
    // }
    console.log("YoutubeVideoComponent!", props);
    return (
        <div className="w-[90%] lg:w-[60%]">
            <div
                className="video-responsive  relative pb-[56.25%] h-0 overflow-hidden"
                style={{ marginTop: "20px", marginBottom: "20px" }}
            >
                <iframe
                    className="absolute top-0 left-0 w-full h-full"
                    src={`https://www.youtube.com/embed/${props.embedId}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title={props.title}
                />
            </div>
        </div>
    );
};

const YoutubeVideoOpenInNewLinkSourceCode = (props: { embedId: string; title?: string }) => {
    // if (typeof window === 'undefined') {   nov 2023: we now render markdown to html on server.
    //   return <></>;
    // }
    console.log("YoutubeVideoOpenInNewLink!", props);
    return (
        <a
            href={`https://www.youtube.com/watch?v=${props.embedId}`}
            className="with-blue"
            target="_blank"
            title={"Watch on YouTube"}
        >
            Watch on YouTube (opens in new tab){" "}
        </a>
    );
};

const PlainVideoPlayer = ({ src, poster, width = "640", height = "360" }) => {
    return (
        <div className="w-[90%] lg:w-[60%]">
            <div className="video-responsive " style={{ marginTop: "20px", marginBottom: "20px" }}>
                <video width={width} height={height} poster={poster} controls>
                    <source src={src} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>
        </div>
    );
};

const Tparagraph = (props: any) => {
    return (
        <p
            className="mt-4 "
            style={{
                //wordSpacing: '1.2px',
                lineHeight: 1.42,
                //letterSpacing: '0.1px',
                ...(props.style || {}),
            }}
            {...props}
        />
    );
};

export const AdditionalMDXComponents = {
    YoutubeVideoComponent: YoutubeVideoComponentSourceCode,
    YoutubeVideoOpenInNewLink: YoutubeVideoOpenInNewLinkSourceCode,
};
